import type { RouteLocationRaw } from 'vue-router'

export type MenuItem = {
  class?: string
  click?: (e: any) => void
  icon?: string
  label: string
  menus?: string[]
  position?: number
  to?: RouteLocationRaw
}

export default defineStore('useMenuStore', () => {
  const menuItemsRef = ref<MenuItem[]>([])

  const menuItems = computed(() => {
    return menuItemsRef.value.sort(
      (a: MenuItem, b: MenuItem) => (a.position ?? 0) - (b.position ?? 0),
    )
  })

  return {
    getMenuItems: (menu?: string) =>
      computed(() => {
        menuItemsRef.value.sort(
          (a: MenuItem, b: MenuItem) => (a.position ?? 0) - (b.position ?? 0),
        )

        return menuItemsRef.value.filter((item) => {
          if (!menu || !item.menus) {
            return true
          }

          return item.menus.includes(menu)
        })
      }),
    menuItems,
  }
})
